module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/venue/venue-events/venue-events.component.scss
// module id = ./src/app/routes/venue/venue-events/venue-events.component.scss
// module chunks = 9